import React, { Component } from "react";
import Comment from "../../../../../common/comments/comment.component";
import { MAX_LENGTH } from "../../../../../../constants/external-constants";
import { Loading } from "../../../../../common/loading";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { outputCommentActions } from "../../../../../../store/external/recharge-reducer/output-configuration-reducer/output-configuration-comments.reducer";

class OutputConfigurationComment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false
        };
    }

    componentDidMount() {
        const { getOutputComments, outputComment } = this.props;

        this.setState({ isLoading: true });
        getOutputComments(this.props.outputConfigurationId, outputComment.pageIndex, 5)
            .then(() => {
                this.setState({ isLoading: false });
            });
    }

    postComment(attachedFilename, attachedFileData, commentDescription) {
        const { postOutputComments } = this.props;
        postOutputComments(this.props.outputConfigurationId, attachedFilename, attachedFileData, commentDescription);
    }

    handleDeleteOutputComments = async (commentId) => {
        this.setState({ isLoading: true });

        const {
            deleteOutputComments,
            getOutputComments,
            resetOutputComments,
            outputComment
        } = this.props;

        await deleteOutputComments(commentId, this.props.outputConfigurationId);
        await resetOutputComments();
        await getOutputComments(this.props.outputConfigurationId, 1, outputComment?.outputComments?.length)
            .then(() => {
                this.setState({ isLoading: false });
            });

        this.setState({ show: false });
    };

    handleLoadMore = async () => {
        const { getOutputComments, outputComment } = this.props;
        await getOutputComments(this.props.outputConfigurationId, outputComment.pageIndex + 1);
    };

    componentWillUnmount() {
        const { resetOutputComments } = this.props;
        resetOutputComments();
    }

    render() {
        const { outputComment, isReadOnly, isReadAndExtractOnly, isReadAndWrite } = this.props;

        if (this.state.isLoading) {
            return <Loading />;
        }
        return (
            <>
                <Comment
                    commentList={outputComment?.outputComments}
                    addCommentAction={this.postComment.bind(this)}
                    deleteCommentAction={this.handleDeleteOutputComments.bind(this)}
                    maxLength={MAX_LENGTH.limit_500}
                    isOutputComment={true}

                    isReadOnly={isReadOnly}
                    isReadAndExtractOnly={isReadAndExtractOnly}
                    isReadAndWrite={isReadAndWrite}

                    handleLoadMore={this.handleLoadMore}
                    hasMoreComments={this.props?.outputComment?.hasMoreComments}
                />
            </>
        );
    }
}

export default connect(
    state => {
        const { outputComment } = state;
        return { outputComment };
    },
    dispatch => bindActionCreators(
        Object.assign({}, outputCommentActions),
        dispatch
    )
)(OutputConfigurationComment);
